import { Logo } from "@acme/ui/logo";

export default function CodemodStudioLoading() {
  return (
    <div className="flex h-full w-full flex-col items-center justify-center gap-4">
      <div className="relative size-14">
        <svg
          className="stroke-primary absolute -inset-4 opacity-80"
          stroke="currentFill"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <circle
              cx="12"
              cy="12"
              r="9.5"
              fill="none"
              strokeWidth="1"
              strokeLinecap="round"
              strokeDasharray="0 150"
              transform="rotate(270 12 12)"
            >
              <animate
                attributeName="stroke-dasharray"
                dur="1s"
                calcMode="spline"
                values="0 150;42 150;42 150;42 150"
                keyTimes="0;0.5;0.95;1"
                keySplines="0.42,0,0.58,1;0.42,0,0.58,1;0.42,0,0.58,1"
                repeatCount="indefinite"
              />
              <animate
                attributeName="stroke-dashoffset"
                dur="1s"
                calcMode="spline"
                values="0;-16;-59;-59"
                keyTimes="0;0.5;0.95;1"
                keySplines="0.42,0,0.58,1;0.42,0,0.58,1;0.42,0,0.58,1"
                repeatCount="indefinite"
              />
            </circle>
            <animateTransform
              attributeName="transform"
              type="rotate"
              dur="2s"
              values="0 12 12;360 12 12"
              repeatCount="indefinite"
            />
          </g>
        </svg>

        <Logo className="absolute inset-0 h-full w-full" />
      </div>

      <span className="text-muted-foreground animate-pulse text-xl">
        Codemod Studio
      </span>
      <span className="sr-only">Loading...</span>
    </div>
  );
}
